import types from "./types";

const initialState = {
    createSurveyData: {},
    surveyData: {},
    submitSurveyData: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_SURVEY_FORM_RESPONSE:
            return {
                ...state,
                createSurveyData: action.payload
            }
        case types.CREATE_SURVEY_FORM_CLEAR:
            return {
                ...state,
                createSurveyData: {}
            }
        case types.FETCH_SURVEY_FORM_RESPONSE:
            return {
                ...state,
                surveyData: action.payload
            }
        case types.FETCH_SURVEY_FORM_CLEAR:
            return {
                ...state,
                surveyData: {}
            }
        case types.SUBMIT_SURVEY_FORM_RESPONSE:
            return {
                ...state,
                submitSurveyData: action.payload
            }
        case types.SUBMIT_SURVEY_FORM_CLEAR:
            return {
                ...state,
                submitSurveyData: {}
            }
        default:
            return state;
    }
}